export const getWeekStart = (locale: string): number => {
  const sundayLocales = ['en-US', 'en-CA', 'fr-CA'];
  const saturdayLocales = ['ar-AE', 'ar-SA'];
  const mondayLocales = [
    'en-GB',
    'de-DE',
    'de-CH',
    'nl-NL',
    'fr-FR',
    'fr-BE',
    'fr-CH',
    'nb-NO',
    'en-EU',
    'en-AE',
    'en-SA',
  ];

  if (sundayLocales.includes(locale)) return 0;
  if (saturdayLocales.includes(locale)) return 6;
  if (mondayLocales.includes(locale)) return 1;
  return 1; // default to Monday
};

export const getWeekdayLabels = (locale: string, weekStartsOn: number): string[] => {
  const formatter = new Intl.DateTimeFormat(locale, { weekday: 'short' });
  return Array.from({ length: 7 }, (_, i) => {
    const day = (i + 1 + weekStartsOn) % 7;
    const date = new Date(Date.UTC(2023, 0, 1 + day));
    return formatter.format(date);
  });
};

export const getLocalizedDatePlaceholder = (locale: string): string => {
  const formatter = new Intl.DateTimeFormat(locale);
  const parts = formatter.formatToParts(new Date(2000, 0, 31));
  return parts
    .map((part) => {
      if (part.type === 'day') return 'DD';
      if (part.type === 'month') return 'MM';
      if (part.type === 'year') return 'YYYY';
      return part.value;
    })
    .join('');
};

/**
 * Returns a normalized date string (YYYY-MM-DD) using local timezone.
 * Uses local date components to avoid timezone shift issues (e.g., late night
 * in UTC+5:30 rolling over to the next day when converted to UTC).
 */
export const getNormalizedDate = (date: Date | string | number): string => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const parseDateInput = (dateInput: Date | string | number): Date => {
  if (dateInput instanceof Date) {
    return new Date(dateInput.getTime());
  }

  if (typeof dateInput === 'string') {
    const trimmed = dateInput.trim();
    const normalizedTimezoneSpacing = trimmed
      .replace(/\s+Z$/i, 'Z')
      .replace(/\s+([+-]\d{2}:?\d{2})$/, '$1');

    const normalized = normalizedTimezoneSpacing.replace(/([+-]\d{2})(\d{2})$/, '$1:$2');
    const parsed = new Date(normalized);

    if (!Number.isNaN(parsed.getTime())) {
      return parsed;
    }

    return new Date(trimmed);
  }

  return new Date(dateInput);
};
